module.exports = __webpack_public_path__ + "img/khaliq.bf88d8a2.jpg";